module.exports = require("@nrwl/workspace/src/utils/app-root");